import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedPosts } from "./relatedPostsApi";


const initialState = {
  posts: [],
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const relatedPosts = createAsyncThunk(
  "relatedPosts/getRelatedPosts",
  async (post) => {
    const responsePosts = await getRelatedPosts(post);
    return responsePosts;
  }
);

const relatedPostsSlice = createSlice({
  name: "relatedPosts",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(relatedPosts.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(relatedPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
      })
      .addCase(relatedPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.posts = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default relatedPostsSlice.reducer;
